import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

/**
 * @Entity Or
 */
@Entity()
export class Or extends AbstractAspect {
  static override _class = 'Or';

  @validate(nonOptional())
  @Field(type => [AbstractAspect], { default: v => v ?? [] })
  filters!: AbstractAspect[];

  constructor(doc: PartialEntityData<Or>) {
    super(doc);
  }

  override getMongoFilter() {
    if (!this.filters || this.filters.length === 0) return {};
    return {
      $or: this.filters.map(f => f.getMongoFilter()),
    };
  }
}
